import StackKit from "@/shared/components/kit/stack";
import { useEffect, useState } from "react";
import WalletManagement from "../components/home/walletManagement";
import WalletBalance from "../components/home/walletBalance";
import TwentyCardCenters from "../components/home/twentyCardCenters";
import Slider from "../components/home/slider";
import { CssBaseline, ThemeProvider } from "@mui/material";
import WalletReports from "../components/home/walletReports";
import Transactions from "../components/home/transactions";
import Layout from "../layout/main";
import theme from "../theme";
import CreditPurchases from "../components/home/creditPurchases";
import { useMutation } from "@tanstack/react-query";
import { postTransactions } from "@/api/user/home";
import BoxKit from "@/shared/components/kit/box";

const HomeUser = () => {
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const { mutate: fetchTransactions, data } = useMutation({
    mutationFn: postTransactions,
  });

  useEffect(() => {
    fetchTransactions({ page: page, size: size });
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Layout>
        <StackKit className="w-full mx-auto">
          <StackKit
            sx={{
              display: "grid",
              width: "100%",
              gap: 2,
              gridTemplateColumns: "1fr",

              "@media (min-width:1010px)": {
                gridTemplateColumns: "1fr 1fr",
              },

              "@media (min-width:1718px)": {
                gridTemplateColumns: "1fr 1fr 1fr",
              },

              alignItems: "start",
            }}
          >
            <StackKit>
              <WalletManagement />
            </StackKit>

            <StackKit sx={{ gap: { md: 4, lg: 8 } }}>
              <WalletBalance />
              <TwentyCardCenters />
            </StackKit>

            {/* Right */}
            <StackKit
              sx={{
                "@media (min-width:1010px) and (max-width:1718px)": {
                  gridColumn: "1 / span 2",
                },
              }}
            >
              <Slider />
            </StackKit>
          </StackKit>
        </StackKit>

        {/* ======= Reports + Transactions Section ======= */}
        <StackKit className="w-full mt-6 flex flex-col gap-4 mx-auto">
          <div className="flex flex-col md:flex-row justify-between gap-4w-full">
            <BoxKit className="w-full md:w-[65%] lg:w-[70%]">
              <WalletReports data={data} />
            </BoxKit>
            <BoxKit className="w-full md:w-[33%] lg:w-[28%]">
              <Transactions data={data} />
            </BoxKit>
          </div>

          {/* ======= Credit Purchases ======= */}
          <BoxKit className="w-full mx-auto">
            <CreditPurchases />
          </BoxKit>
        </StackKit>

        <StackKit direction="row" className="w-full mx-auto"></StackKit>
      </Layout>
    </ThemeProvider>
  );
};

export default HomeUser;
